var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_7498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9751C6.95329 20.9751 3 17.0219 3 11.9751C3.30632 0.0400515 20.6953 0.0428634 21 11.9752C21 17.0219 17.0468 20.9751 12 20.9751ZM12 3.74854C7.38697 3.74854 3.77344 7.36208 3.77344 11.9751C4.05346 22.8845 19.9481 22.8819 20.2266 11.975C20.2266 7.36208 16.613 3.74854 12 3.74854Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3796 12.3618H7.62038C7.10783 12.3428 7.10822 11.6072 7.62038 11.5884H16.3796C16.8922 11.6074 16.8918 12.343 16.3796 12.3618Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_7498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.48fa37852d7af7c6ab1ea11ef2b64c4c.svg";
export { ForwardRef as ReactComponent };